import * as APIM from '@common/utils/dist/models/api-messages.js';
import * as PL2 from '@common/utils/dist/models/models-pl2.js';
import {KeyUtilsPL2 as KU} from '@common/utils/dist/utils/key-utils-pl2.js';
import {EntryState, EntryStore} from '@stores/entry.store';
import {PendingOperation} from '@stores/entry-store-automaton/operation-state-machine';
import {EntryEventChainOutput, EntryEventHandler} from './entry-event-core';

export class ArrayBuilderHandler implements EntryEventHandler<
  EntryState,
  EntryEventChainOutput
> {
  nextHandler: EntryEventHandler<EntryEventChainOutput, any>;

  constructor(private entryStore: EntryStore) {}

  handle(entryState: EntryState): EntryEventChainOutput {
    const expired = new Array<string>();
    const changes: Partial<
      Record<APIM.EventIntent, Array<PL2.AnyPartialEntryWithId>>
    > = {
      [APIM.EventIntent.EntryCreate]: [],
      [APIM.EventIntent.EntryDeepDelete]: [],
      [APIM.EventIntent.EntryBatchUpdate]: [],
    };
    Object.keys(entryState).forEach((pK) => {
      const ce = entryState[pK];
      const entry = ce.e as PL2.AnyPartialEntryWithId;
      switch (ce.pO) {
        case PendingOperation.Create:
          changes[APIM.EventIntent.EntryCreate].push(entry);
          break;
        case PendingOperation.Delete:
          changes[APIM.EventIntent.EntryDeepDelete].push(entry);
          break;
        case PendingOperation.Update:
          changes[APIM.EventIntent.EntryBatchUpdate].push(
            ce._payload[ce._payload.length - 1],
          );
          break;
        case PendingOperation.DeleteFailed:
        case PendingOperation.CreateFailed:
        case PendingOperation.UpdateFailed:
          const ceTs = parseInt(ce._ts, 10);
          const currentTs = new Date().getTime();
          const input =
            ce.pO === PendingOperation.DeleteFailed
              ? PendingOperation.Delete
              : ce.pO === PendingOperation.CreateFailed
                ? PendingOperation.Create
                : PendingOperation.Update;
          if (currentTs - ceTs > 30_000) {
            this.entryStore.advanceCachedEntryState(
              [KU.pKFromString(pK)],
              input,
            );
          }
          break;
        case PendingOperation.Ignore:
          expired.push(pK);
          break;
        default:
        // do nothing
      }
    });

    return this.nextHandler.handle({
      expired,
      changes,
    });
  }
}
